import { Box, Grid, Typography } from '@mui/material';
import { EnvelopeIcon } from '@/app/icons/EnvelopeIcon';
import { ForeignNumberNotice } from '@/components/common/phone/ForeignNumberNotice';
import { PhoneCodeForm } from '@/components/profile/modals/phone/PhoneCodeForm';
import { PhoneEntryForm } from '@/components/profile/modals/phone/PhoneEntryForm';
import { Theme } from '@mui/material/styles';
import React, { FC, ReactElement } from 'react';
import type { PhoneVerificationFlow } from '@/components/common/phone/usePhoneVerificationFlow';

interface Props {
  flow: PhoneVerificationFlow;
  isAddPhone?: boolean;
  isMobile?: boolean;
  username?: string;
}

/**
 * Body of the number-entry and SMS-code steps.
 *
 * @param props The flow state, which endpoint pair to use, the viewport and an optional login to display.
 */
export const PhoneVerificationBody: FC<Props> = (props: Props): ReactElement => {
  const { flow, isAddPhone, isMobile, username } = props;

  return (
    <Grid container={true} direction={'column'} rowSpacing={2} data-testid={'phone-verification-body'}>
      {username && (
        <Grid item={true}>
          <Box
            data-testid={'phone-verification-login'}
            display={'flex'}
            alignItems={'center'}
            borderRadius={'12px'}
            padding={(theme: Theme) => theme.spacing(1.75, 2)}
            sx={{ backgroundColor: (theme: Theme) => theme.colors.grayBackground }}>
            <EnvelopeIcon
              sx={{
                width: '20px',
                height: '20px',
                marginRight: (theme: Theme) => theme.spacing(1.5),
                color: (theme: Theme) => theme.colors.primary,
              }}
            />
            <Typography variant={'body1'}>{username}</Typography>
          </Box>
        </Grid>
      )}
      <Grid item={true}>
        {flow.step === 'phone' ? (
          <PhoneEntryForm
            initialPhone={flow.phone}
            isAddPhone={isAddPhone}
            handleSubmit={flow.handleCodeSent}
            submitButtonRef={flow.submitButtonRef}
            onLoading={flow.setLoading}
          />
        ) : (
          <PhoneCodeForm
            newPhone={flow.phone}
            isAddPhone={isAddPhone}
            isMobile={isMobile}
            setSuccessChange={flow.handleConfirmed}
            submitButtonRef={flow.submitButtonRef}
            onLoading={flow.setLoading}
            initialCooldownSeconds={flow.cooldownSeconds}
            initialBlockSeconds={flow.blockSeconds}
          />
        )}
      </Grid>
      {flow.step === 'phone' && (
        <Grid item={true}>
          <ForeignNumberNotice />
        </Grid>
      )}
    </Grid>
  );
};
